import { CONTACT_US_URL } from 'config/constants';
import { contactUsLinkSelected } from 'lib/gaTracking/crossPageEvents';
import { Link, Text } from '@qga/roo-ui/components';

const NameFootnote = () => (
  <Text fontSize="14px">
    <Link target="_blank" href={CONTACT_US_URL} onClick={contactUsLinkSelected}>
      Contact us
    </Link>{' '}
    to change the guest name
  </Text>
);

export default NameFootnote;
